import React from 'react'
import { FiDownload } from '@react-icons/all-files/fi/FiDownload'

const DownloadBtn = () => {
    return (
        <>
            <FiDownload className="green-btn-plus"/>
        </>
    )
}
export default DownloadBtn